"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useENSAddress = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var swr_1 = tslib_1.__importDefault(require("swr"));

var NFTFetchContext_1 = require("../context/NFTFetchContext");
/**
 * useENSAddress - Load ens address for pretty display of user addresses
 *
 * @param address string address to fetch zora username of
 * @returns DomainResolvedPartFragment
 */


function useENSAddress(address, options) {
  var fetcher = react_1.useContext(NFTFetchContext_1.NFTFetchContext);
  return swr_1.default(address ? ['loadENS', address.toLowerCase()] : null, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, address) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fetcher.loadEnsName(address));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), options);
}

exports.useENSAddress = useENSAddress;